<template>
	<b-nav-item :class="!disabledNavbar ? 'icons profile-menu' : 'icons-disabled'">
		<div class="profile-image-holder">
			<img class="profileImg" :src="userInfo.profile_picture || defaultProfileImage" alt />
			<span class="profile-name">ME</span>
			<div class="arrow-down"></div>
		</div>
		<profile-menu :userInfo="userInfo" />
	</b-nav-item>
</template>

<script>
import defaultProfileImage from '../assets/default-user-profile-image.png';
import ProfileMenu from './ProfileMenu.vue';

export default {
	name: 'ProfileWithMenu',
	components: {
		ProfileMenu,
	},
	props: {
		userInfo: {
			type: Object,
			required: true
		},
		disabledNavbar: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			defaultProfileImage,
		}
	},
}
</script>
 
<style src="./NavbarPersonal.css" scoped></style>
<style scoped>
	.profile-image-holder {
		display: flex;
		align-items: center;
		flex-direction: column;	
		padding-top: 25px;
		position: relative;
	}

	.profile-image-holder .arrow-down {
		position: absolute;
		top: 45%;
		right: -15px;
		border: solid black;
		border-width: 0 1px 1px 0;
		display: inline-block;
		padding: 3px;
		transform: rotate(45deg);
		-webkit-transform: rotate(45deg);
	}

	.profile-image-holder:hover .arrow-down {
		border: solid #bd9d5f;
		border-width: 0 1px 1px 0;
	}

	.profile-name {
		color: rgb(41, 41, 41);
		font-family: "Montserrat", sans-serif;
		font-size: 10px;
		text-transform: uppercase;
		margin-top: 2px;
	}
</style>